import heading from './heading'

export default {
  fontFamily: ['proxima-nova', 'adelle'],
  fontSize: '16px',
  lineHeight: 1.2,
  fontWeight: '400',
  heading: heading,
  overline: {
    uppercase: true,
    max: {
      fontSize: 16,
      lineHeight: 20
    },
    min: {
      fontSize: 12,
      lineHeight: 16
    }
  }
}
